import React from 'react';
import { Button, ThemeProvider } from "@kaena1/mm-ui-components";
import { PlanCard } from "@kaena1/mm-ui-mint-components";
import {theme} from "@kaena1/mm-ui-theme-v3";

export const App = () => {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <h1>Hello World</h1>
        <PlanCard dataAmount={5} cost={15} ctaButton={<Button>View Details</Button>} />
      </ThemeProvider>
    </div>
  );
};